export default __webpack_public_path__ + "static/media/my-sql-logo.28e6670f.png";